module.exports = __webpack_public_path__ + "media/images/ioc-logo-8f6687893197c9ae24aaa60836909590.png";